exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mt-20[data-v-49442c0c]{\n  margin-top: -20px;\n}\n.link[data-v-49442c0c]:hover {\n  text-decoration: underline;\n}\n", ""]);

// exports
